<template>
  <div class="update-history">
    <el-dialog
      title="Salesman Update History"
      :modelValue="modelValue"
      width="930px"
      @closed="CloseDialog"
    >
      <el-scrollbar height="500px" style="padding: 0 11px">
        <div v-for="(item, index) in SalesRecords" :key="'salesrecord' + index">
          <div
            style="
              display: flex;
              line-height: 20px;
              position: relative;
              padding-left: 30px;
            "
          >
            <el-icon
              class="icon-shape-left"
              style="
                padding: 4.5px;
                border-radius: 3px;
                width: 16px;
                height: 16px;
                font-weight: 700;
                position: absolute;
                left: 0;
              "
            >
              <svg-icon iconClass="shape-left"></svg-icon
            ></el-icon>
            <div>Last Update: {{ item.updateByName }}</div>
            <div style="flex-grow: 1; text-align: right">
              {{ formatter_datetime(item.updateDate, 'DD/MM/YYYY HH:mm') }}
            </div>
          </div>
          <div class="update-history__text">
            <div>
              <div>
                Effective Date:
                {{ formatter_date(item.effectiveDate, 'DD/MM/YYYY') }}
              </div>
              <div>
                <div class="update-history__label">To:</div>
              </div>
              <div>
                <div>
                  Salesman: {{ item.salesmanName }}, Team Head:
                  {{ item.teamHeadName }}, Sales Head: {{ item.salesHeadName }},
                  Pool Head: {{ item.poolHeadName }}
                </div>
              </div>
              <div>
                <div class="update-history__label">From:</div>
              </div>
              <div>
                <div>
                  <div>
                    Salesman: {{ item.lastSalesmanName }}, Team Head:
                    {{ item.lastTeamHeadName }}, Sales Head:
                    {{ item.lastSalesHeadName }}, Pool Head:
                    {{ item.lastPoolHeadName }}
                  </div>
                </div>
                <div>Remark: {{ item.remark }}</div>
              </div>
            </div>
          </div>
          <el-divider /></div
      ></el-scrollbar>
      <template #footer>
        <div style="text-align: center">
          <el-button link type="primary"> Show More History </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import baseButton from '@/components/newUI/BaseButton';
import { ref } from 'vue';
import { useOrderStore } from '@/store/order';
import { formatter_date, formatter_datetime } from '@/assets/js/formatter';
import booknet from '@/network/booknet';

defineProps({
  modelValue: {
    type: Boolean,
  },
});

const useOrder = useOrderStore();

const emits = defineEmits(['update:modelValue']);

const SalesRecords = ref([]);
const init = () => {
  booknet.getOrderChangeRecords(useOrder.Id).then((res) => {
    SalesRecords.value = res.data?.data || [];
  });
};
init();

// 关闭窗口
const CloseDialog = () => {
  emits('update:modelValue', false);
};
</script>
<style scoped>
.update-history__text {
  line-height: 32px;
  font-size: 14px;
  padding-left: 30px;
  color: #979797;
}

.update-history__label {
  color: #524235;
}
</style>
